import { render, staticRenderFns } from "./block-item.vue?vue&type=template&id=f16aa69e"
import script from "./block-item.vue?vue&type=script&lang=js"
export * from "./block-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports